module.exports = __webpack_public_path__ + "static/fabric-calendar-month-year-switch-55083e20914ae0c3a41e80286186803a.gif";